<template>

  <div class="container">

    <div class="handle-box-search">

      <el-row class="head-search">
        <el-col :span="8">
          <span class="title">姓名:</span>
          <!-- 搜索司机名称-->
          <el-input
            v-model="search_data.name"
            placeholder="请输入姓名 "
            class="handle-input mr10"
            @keyup.enter.native="searchpinganLists"
          ></el-input>
        </el-col>
        <el-col :span="8">
          <span class="title">用户名:</span>
          <!-- 搜索司机名称-->
          <el-input
            v-model="search_data.user_name"
            placeholder="请输入用户名 "
            class="handle-input mr10"
            @keyup.enter.native="searchpinganLists"
          ></el-input>
        </el-col>

      </el-row>

      <el-row class="head-search">

        <el-col :span="8">
          <span class="title">手机号:</span>
          <!-- 搜索司机名称-->
          <el-input
            v-model="search_data.phone"
            placeholder="请输入手机号 "
            class="handle-input mr10"
            @keyup.enter.native="searchpinganLists"
          ></el-input>
        </el-col>

      </el-row>

      <el-button
        type="primary"
        icon="el-icon-search"
        @click="searchpinganLists"
      >搜索</el-button>
      <el-button @click="add_isShow=!add_isShow">添加</el-button>
      <el-button
        icon="el-icon-refresh-right"
        @click="refresh"
      >刷新</el-button>

    </div>

    <!-- 表格 -->
    <el-table
      :data="tableData"
      style="width: 100%"
      ref="multipleTable"
      header-cell-class-name="table-header"
      @selection-change="handleSelectionChange"
    >

      <el-table-column
        type="selection"
        width="55"
        align="center"
        prop="pingan_admin_code"
      ></el-table-column>
      <el-table-column type="expand">
        <template slot-scope="props">

          <!-- 表格下拉 -->

          <el-form
            label-position="left"
            inline
            class="demo-table-expand"
          >
            <div class="more-style">
              <el-form-item label="创建时间:">
                <span>{{ props.row.reg_time.YmdHis }}</span>
              </el-form-item>

            </div>
          </el-form>

        </template>
      </el-table-column>

      <el-table-column
        prop="id"
        label="id"
        width="80"
      >
      </el-table-column>

      <el-table-column
        prop="name"
        label="姓名"
      >
      </el-table-column>

      <el-table-column
        prop="user_name"
        label="账号"
      >
      </el-table-column>

      <el-table-column
        prop="phone"
        label="手机号"
      >
      </el-table-column>

      <el-table-column label="状态">
        <template slot-scope="scope">
          <el-tag :type="scope.row.status.val=='0'?'':(scope.row.status.val=='1'?'danger':'warning')">
            {{scope.row.status.alias}}</el-tag>

        </template>
      </el-table-column>

      <!-- <el-table-column label="状态">
        <template slot-scope="scope">
          <el-tag
            size="medium"
            style="border:0;background-color:#FFF;color:#333"
            type="success"
          >{{ scope.row.status.alias }}</el-tag>
        </template>
      </el-table-column> -->

      <el-table-column
        label="操作"
        width="150"
      >
        <template slot-scope="scope">

          <el-dropdown
            split-button
            type="primary"
            trigger="click"
            @click="edit_isShow = !edit_isShow; data_children = scope.row.pingan_admin_code;"
          >

            编辑
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item @click.native="editStatus(scope.row.pingan_admin_code,'1')" v-if="scope.row.status.val == 0">禁用</el-dropdown-item>
              <el-dropdown-item @click.native="editStatus(scope.row.pingan_admin_code,'0')" v-else>启用</el-dropdown-item>
            </el-dropdown-menu>

          </el-dropdown>

        </template>
      </el-table-column>

    </el-table>
    <el-button
      type="primary"
      icon="el-icon-delete"
      class="handle-del mr10"
      @click="deleteData"
      style="margin-top: 20px;"
    >批量删除</el-button>
    <!-- 分页组件 -->
    <div class="pagination">
      <pages
        :search_data="search_data"
        :result_data="result_data"
        @pages_function="pages_function"
      ></pages>
    </div>

    <!-- 添加组件 -->
    <addPingan
      :isShow="add_isShow"
      @onSubmit="pinganLists"
    ></addPingan>

    <!-- 添加组件 -->
    <editPingan
      :isShow="edit_isShow"
      :data="data_children"
      @onSubmit="pinganLists"
    ></editPingan>

  </div>

</template>

<script>
var _this;
import addPingan from './addPingan.vue';
import editPingan from './editPingan.vue';
export default {
    components: {
        addPingan,
        editPingan
    },
    data() {
        return {

            add_isShow: false,

            edit_isShow: false,

            data_children: '',

            // 批量删除
            delDriverSubmit_data: {
                pingan_admin_code_array: []
            },
            delDriverSubmit_rules: {
                pingan_admin_code_array: {
                    placeholder: '权限模块',
                    rules: {
                        required: false,
                        message: '权限模块代码数组(json)',
                        regulation: 'special',
                        rulesData: 'json_array'
                    }
                }
            },

            // 下拉搜索城市
            value_city_code: '',
            options_city_code: [],
            city_options_data: {
                page: 1,
                limit: 50,
                name: ''
            },
            company_name: '',

            val_port_array: '',

            // 存放表格数据
            tableData: [],

            //翻页数据
            search_data: {
                page: 1,
                limit: 10,
                name: '',
                user_name: '',
                phone: ''
            },

            result_data: [],
            search_rules: {
                page: {
                    placeholder: '页码',
                    rules: {
                        required: true,
                        message: '页码需要大于0',
                        regulation: 'gt',
                        rulesData: 0
                    }
                },
                limit: {
                    placeholder: '每页个数',
                    rules: {
                        required: true,
                        message: '每页个数需在1-51之内',
                        regulation: 'between',
                        rulesData: [1, 51]
                    }
                }
            }
        };
    },
    created() {
        _this = this;
        _this.pinganLists();
    },

    methods: {
        editStatus(code,val) {
            _this
                .$post('/pinganadmin/executePinganStatusSubmit', {
                    pingan_admin_code: code,
                    status:val
                })
                .then((res) => {
                  _this.pinganLists();
                  _this.$message.success(res.msg);
                })
                .catch((err) => {});
        },
        searchpinganLists() {
            _this.search_data.page = 1;
            _this.pinganLists();
        },
        cityChange(val) {
            _this.search_data.city_code = val;
            if (val != '') {
                _this
                    .$post('/city/getCityDetails', {
                        city_code: val
                    })
                    .then((res) => {
                        _this.company_name = res.data.company.name;
                    })
                    .catch((err) => {});
            } else {
                _this.company_name = '';
            }
        },
        //搜索的下拉框弹出触发
        cityVisibleChange(val) {
            if (val && _this.options_city_code.length < 1) {
                // 请求公司管理接口获取公司唯一编码
                _this
                    .$post('/city/cityLists', _this.city_options_data)
                    .then((res) => {
                        _this.options_city_code = res.data;
                    })
                    .catch((err) => {});
            }
        },

        // 搜索司机审核列表
        pinganLists() {
            _this
                .$post('/pinganadmin/pinganadminLists', _this.search_data, _this.search_rules)
                .then((res) => {
                    // 将请求的数据存放到表格数据数组中
                    _this.tableData = res.data;
                    _this.result_data = res;
                })
                .catch((err) => {});
        },
        //翻页组件的回调
        pages_function(search_data) {
            //赋值
            _this.search_data = search_data;
            //初始化列表
            _this.pinganLists();
        },

        handleSelectionChange(val) {
            var datalist = [];

            for (var i in val) {
                datalist.push(val[i].pingan_admin_code);
            }
            _this.delDriverSubmit_data.pingan_admin_code_array = datalist;
        },
        // 批量删除
        deleteData() {
            if (_this.delDriverSubmit_data.pingan_admin_code_array.length == 0) {
                _this.$message.warning('请至少勾选一条数据');

                return;
            }

            _this
                .$confirm('此操作将删除该条数据, 是否继续?', '提示', {
                    confirmButtonText: '确定',

                    cancelButtonText: '取消',

                    type: 'warning'
                })
                .then(() => {
                    _this.delDriverSubmit_data.pingan_admin_code_array = JSON.stringify(_this.delDriverSubmit_data.pingan_admin_code_array);

                    _this
                        .$post('/pinganadmin/delPinganAdminSubmit', _this.delDriverSubmit_data, _this.delDriverSubmit_rules)
                        .then((res) => {
                            _this.$message.success('删除成功!');

                            //初始化显示列表
                            _this.pinganLists();
                        })
                        .catch((err) => {});
                })
                .catch(() => {
                    _this.$message.info('已取消删除');
                });
        },

        // 刷新按钮
        refresh() {
            this.$router.go(0);
        }
    }
};
</script>

<style scoped>
.handle-box {
    margin-bottom: 20px;
}

.handle-select {
    width: 120px;
}

.handle-input {
    width: 200px;
    display: inline-block;
}

.table {
    width: 100%;
    font-size: 14px;
}

.red {
    color: #ff0000;
}

.mr10 {
    margin-right: 10px;
}

.table-td-thumb {
    display: block;
    margin: auto;
    width: 40px;
    height: 40px;
}

.el-table__row {
    height: 100px;
}

.el-form-item.el-form-item--small {
    width: 100%;
}

.demo-table-expand {
    font-size: 0;
}

.demo-table-expand label {
    width: 90px;
    color: #99a9bf;
}

.demo-table-expand .el-form-item {
    margin-right: 0;
    margin-bottom: 0;
}

.el-form-item__content span {
    display: inline-block;
    width: 100%;
    word-wrap: break-word;
    white-space: normal;
}
</style>